import { BlogPost } from './types';

export const BLOG_POSTS: BlogPost[] = [
  {
    id: "yunanistan-golden-visa-vergi-artisi-yuzde-15",
    title: "Yunanistan Golden Visa’da Kritik Eşik: %3’ten %15’e Vergi Artışı Yatırımcı Maliyetlerini Nasıl Etkileyecek?",
    summary: "Yunanistan hükümetinin gayrimenkul alım vergisini (FMA) %3'ten %15'e çıkarma tasarısı, 250.000€, 400.000€ ve 800.000€ yatırım dilimlerindeki ek maliyetler ve Türk yatırımcılar için açık fırsat penceresi rehberi.",
    category: "Mevzuat & Vergi",
    author: "GrecoTurk Hukuki Danışmanlar",
    date: "08 Mart 2025",
    readTime: "5 dk okuma",
    imageUrl: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&q=80&w=1000",
    content: `
      <div class="bg-rose-50 border-l-4 border-rose-600 p-5 rounded-r-xl mb-8 shadow-sm">
        <div class="flex items-center gap-2 text-rose-800 font-bold text-base mb-1.5">
          <span class="inline-block w-2.5 h-2.5 rounded-full bg-rose-600 animate-pulse"></span>
          ÖNEMLİ DÜZELTME VE ACİL UYARI
        </div>
        <p class="text-rose-950 font-medium text-sm leading-relaxed">
          Yunanistan hükümetinin gündemindeki <strong>%15’lik yeni vergi düzenlemesi henüz kanunlaşmış değil!</strong> Süreç resmiyet kazanmadan önce işlemleri başlatıp mevcut mevzuattan yararlanan Türk yatırımcılar, %15 yerine sadece mevcut <strong>%3’lük alım vergisini</strong> ödeyerek yüz binlerce Euro’ya varan devasa bir maliyet avantajını koruyabilecek. Karar yürürlüğe girmeden önce adım atmak bu süreçte kritik önem taşıyor.
        </p>
      </div>

      <p class="text-lg text-gray-700 leading-relaxed mb-6">
        Atina’da gündeme bomba gibi düşen gayrimenkul alım vergisi artışı tartışmaları, Komşu’da ev sahibi olarak Avrupa oturum izni almayı hedefleyen Türk yatırımcılar için hesapları sil baştan değiştirebilir.
      </p>

      <p class="mb-6 leading-relaxed">
        Yunanistan hükümetinin gündemine aldığı ve Başbakan’ın son açıklamalarıyla kamuoyunda geniş yankı uyandıran yeni vergi düzenlemesi, gayrimenkul alım vergisini (FMA) mevcut %3 seviyesinden %15’e çıkarmayı öngörüyor. Henüz kanunlaşmamış ve uygulama detayları netleşmemiş olsa da bu <strong>5 katlık vergi artışı ihtimali</strong>, Golden Visa (Altın Vize) yatırımlarında ödenecek ek maliyetleri ve toplam bütçeleri ciddi oranda yukarı çekiyor.
      </p>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">
        Farklı Yatırım Alt Sınırlarına Göre Yeni Vergi Tablosu
      </h3>
      <p class="mb-6">
        Peki bu olası düzenleme yürürlüğe girerse, farklı yatırım alt sınırlarına göre Türk yatırımcıların cebinden çıkacak ek vergi yükü ne kadar olacak? İşte rakamlarla net tablo:
      </p>

      <!-- Comparison Cards -->
      <div class="space-y-6 my-8">
        
        <!-- Segment 1: 250k -->
        <div class="border border-gray-200 rounded-2xl p-6 bg-white shadow-sm hover:border-greek-300 transition-colors">
          <div class="flex items-center justify-between flex-wrap gap-2 mb-4 pb-3 border-b border-gray-100">
            <h4 class="text-lg font-bold text-gray-900">
              1. 250.000 Euro’luk Yatırım Segmenti
            </h4>
            <span class="text-xs font-semibold px-3 py-1 bg-amber-100 text-amber-800 rounded-full">
              Dönüştürülen / Restore Edilen Gayrimenkuller
            </span>
          </div>
          <p class="text-sm text-gray-600 mb-4">
            Yunanistan'da ticari mülkten konuta dönüştürülen veya tarihi mülk restorasyonlarını kapsayan 250.000 Euro’luk alt sınırda:
          </p>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
            <div class="bg-gray-50 p-3.5 rounded-xl border border-gray-100">
              <span class="text-xs text-gray-500 block">Mevcut Durum (%3 Vergi)</span>
              <span class="text-lg font-bold text-emerald-700">7.500 €</span>
            </div>
            <div class="bg-rose-50 p-3.5 rounded-xl border border-rose-100">
              <span class="text-xs text-rose-600 block font-medium">Yeni Tasarı (%15 Vergi)</span>
              <span class="text-lg font-bold text-rose-700">37.500 €</span>
            </div>
            <div class="bg-amber-50 p-3.5 rounded-xl border border-amber-200">
              <span class="text-xs text-amber-700 block font-semibold">Net Ek Maliyet Farkı</span>
              <span class="text-lg font-bold text-amber-900">+30.000 € (5 Kat Artış)</span>
            </div>
          </div>
        </div>

        <!-- Segment 2: 400k -->
        <div class="border border-gray-200 rounded-2xl p-6 bg-white shadow-sm hover:border-greek-300 transition-colors">
          <div class="flex items-center justify-between flex-wrap gap-2 mb-4 pb-3 border-b border-gray-100">
            <h4 class="text-lg font-bold text-gray-900">
              2. 400.000 Euro’luk Yatırım Segmenti
            </h4>
            <span class="text-xs font-semibold px-3 py-1 bg-blue-100 text-blue-800 rounded-full">
              Belirli Bölgeler ve Standart Mülkler
            </span>
          </div>
          <p class="text-sm text-gray-600 mb-4">
            Genel konut segmentinde yer alan 400.000 Euro’luk mülk alımlarında:
          </p>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
            <div class="bg-gray-50 p-3.5 rounded-xl border border-gray-100">
              <span class="text-xs text-gray-500 block">Mevcut Durum (%3 Vergi)</span>
              <span class="text-lg font-bold text-emerald-700">12.000 €</span>
            </div>
            <div class="bg-rose-50 p-3.5 rounded-xl border border-rose-100">
              <span class="text-xs text-rose-600 block font-medium">Yeni Tasarı (%15 Vergi)</span>
              <span class="text-lg font-bold text-rose-700">60.000 €</span>
            </div>
            <div class="bg-amber-50 p-3.5 rounded-xl border border-amber-200">
              <span class="text-xs text-amber-700 block font-semibold">Net Ek Maliyet Farkı</span>
              <span class="text-lg font-bold text-amber-900">+48.000 € Ek Vergi</span>
            </div>
          </div>
        </div>

        <!-- Segment 3: 800k -->
        <div class="border border-gray-200 rounded-2xl p-6 bg-white shadow-sm hover:border-greek-300 transition-colors">
          <div class="flex items-center justify-between flex-wrap gap-2 mb-4 pb-3 border-b border-gray-100">
            <h4 class="text-lg font-bold text-gray-900">
              3. 800.000 Euro’luk Yatırım Segmenti
            </h4>
            <span class="text-xs font-semibold px-3 py-1 bg-purple-100 text-purple-800 rounded-full">
              Atina, Selanik, Mykonos, Santorini vb.
            </span>
          </div>
          <p class="text-sm text-gray-600 mb-4">
            Yoğun talep gören metropollerde ve popüler adalarda geçerli olan 800.000 Euro’luk üst sınırda ise rakamlar oldukça çarpıcı bir boyuta ulaşıyor:
          </p>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
            <div class="bg-gray-50 p-3.5 rounded-xl border border-gray-100">
              <span class="text-xs text-gray-500 block">Mevcut Durum (%3 Vergi)</span>
              <span class="text-lg font-bold text-emerald-700">24.000 €</span>
            </div>
            <div class="bg-rose-50 p-3.5 rounded-xl border border-rose-100">
              <span class="text-xs text-rose-600 block font-medium">Yeni Tasarı (%15 Vergi)</span>
              <span class="text-lg font-bold text-rose-700">120.000 €</span>
            </div>
            <div class="bg-amber-50 p-3.5 rounded-xl border border-amber-200">
              <span class="text-xs text-amber-700 block font-semibold">Net Ek Maliyet Farkı</span>
              <span class="text-lg font-bold text-amber-900">+96.000 € Ek Maliyet</span>
            </div>
          </div>
        </div>

      </div>

      <!-- Quick Summary Table -->
      <div class="overflow-x-auto my-8 border border-gray-200 rounded-2xl shadow-sm">
        <table class="min-w-full divide-y divide-gray-200 text-left text-sm">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="py-3.5 px-4 font-bold text-gray-900">Yatırım Tutarı</th>
              <th scope="col" class="py-3.5 px-4 font-bold text-emerald-800">Mevcut Vergi (%3)</th>
              <th scope="col" class="py-3.5 px-4 font-bold text-rose-800">Olası Yeni Vergi (%15)</th>
              <th scope="col" class="py-3.5 px-4 font-bold text-gray-900">Ekstra Vergi Yükü</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 bg-white">
            <tr>
              <td class="py-3 px-4 font-semibold text-gray-900">250.000 €</td>
              <td class="py-3 px-4 text-emerald-700 font-bold">7.500 €</td>
              <td class="py-3 px-4 text-rose-600 font-bold">37.500 €</td>
              <td class="py-3 px-4 font-bold text-amber-700">+30.000 €</td>
            </tr>
            <tr class="bg-gray-50/50">
              <td class="py-3 px-4 font-semibold text-gray-900">400.000 €</td>
              <td class="py-3 px-4 text-emerald-700 font-bold">12.000 €</td>
              <td class="py-3 px-4 text-rose-600 font-bold">60.000 €</td>
              <td class="py-3 px-4 font-bold text-amber-700">+48.000 €</td>
            </tr>
            <tr>
              <td class="py-3 px-4 font-semibold text-gray-900">800.000 €</td>
              <td class="py-3 px-4 text-emerald-700 font-bold">24.000 €</td>
              <td class="py-3 px-4 text-rose-600 font-bold">120.000 €</td>
              <td class="py-3 px-4 font-bold text-amber-700">+96.000 €</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3 class="text-2xl font-bold text-gray-900 mt-10 mb-4">
        TÜRK YATIRIMCILAR İÇİN NE ANLAMA GELİYOR?
      </h3>
      <p class="mb-4 leading-relaxed">
        Yunanistan Golden Visa programı; sunduğu Schengen vizesiz serbest dolaşım hakkı, Euro bazlı kira getirisi potansiyeli ve Avrupa’da ailece yaşama fırsatıyla Türk yatırımcılar arasında yıllardır ilk sırada yer alıyor. Ancak gayrimenkul alım vergisinin %3’ten %15’e çıkarılması fikri, yatırımın geri dönüş süresini (ROI) ve toplam giriş maliyetini doğrudan etkileyecektir.
      </p>

      <ul class="list-disc pl-5 space-y-3 mb-6 text-gray-700">
        <li>
          <strong>Fırsat Penceresi Halen Açık:</strong> Karar henüz yasalaşmadığı ve yürürlük tarihi kesinleşmediği için mevcut %3’lük vergi avantajından yararlanmak halen mümkündür.
        </li>
        <li>
          <strong>Zamanlama Kritik:</strong> Geçmişte Golden Visa alt sınırlarının artırılması sürecinde yaşandığı gibi, geçiş dönemleri ve kazanılmış haklar büyük önem taşıyor. İşlemlerini başlatmayı düşünen Türk yatırımcıların, olası kanunlaşma öncesinde adımlarını hızlandırmaları 30.000 € ile 96.000 € arasında net tasarruf sağlayacaktır.
        </li>
      </ul>

      <div class="bg-greek-50 border border-greek-200 p-5 rounded-2xl my-8">
        <h4 class="text-greek-900 font-bold text-base mb-2">Hukuki Süreci Güvenle Başlatmak İçin:</h4>
        <p class="text-greek-800 text-sm leading-relaxed mb-3">
          GrecoTurk Hukuk Bürosu olarak Atina ve Türkiye ofislerimiz üzerinden vekaletname tanzimi, tapu araştırması ve ön protokol süreçlerini hızlandırarak mevcut %3 vergi avantajından yararlanmanızı sağlıyoruz.
        </p>
        <p class="text-xs text-greek-600 font-medium">
          * Gelişmeleri ve yasal sürecin tüm detaylarını yakından takip etmeye devam edeceğiz.
        </p>
      </div>
    `
  },
  {
    id: "golden-visa-2025-yeni-duzenlemeler",
    title: "Yunanistan Golden Visa 2025: Yeni Bölgeler ve Yatırım Şartları Rehberi",
    summary: "Yunanistan'ın güncellenen Golden Visa mevzuatı kapsamında değişen minimum yatırım tutarları (800.000€, 400.000€ ve 250.000€) ve Türk yatırımcılar için stratejik hukuki tavsiyeler.",
    category: "Yatırım",
    author: "GrecoTurk Hukuki Danışmanlar",
    date: "10 Ocak 2025",
    readTime: "7 dk okuma",
    imageUrl: "https://images.unsplash.com/photo-1560769629-975ec94e6a86?auto=format&fit=crop&q=80&w=1000",
    content: `
      <p class="mb-4">Yunanistan Golden Visa programı, Türk vatandaşları için Avrupa Birliği sınırlarında serbest dolaşım, emlak yatırımı ve aile için güvenli bir B planı sunmaya devam ediyor. Yunanistan Parlamentosu'nun onayladığı son yasal düzenlemeyle birlikte programda önemli bölgesel eşikler yürürlüğe girmiştir.</p>
      
      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Yeni Yatırım Eşikleri: 800.000€, 400.000€ ve 250.000€</h3>
      <p class="mb-4">Yunanistan hükümeti, konut arzını dengelemek amacıyla bölgesel bir kademelendirme getirmiştir:</p>
      <ul class="list-disc pl-5 space-y-2 mb-6">
        <li><strong>800.000 Euro Bölgesi:</strong> Attika Bölgesi'nin tamamı (Atina merkezi, Atina Rivierası, Pire ve banliyöler), Selanik kentsel alanı, Mikonos, Santorini ve nüfusu 3.100'ün üzerindeki adalarda tek bir konut için asgari tutar 800.000 Euro'dur.</li>
        <li><strong>400.000 Euro Bölgesi:</strong> Yukarıdaki bölgelerin dışında kalan anakara Yunanistan şehirleri ve küçük adalarda asgari yatırım sınırı 400.000 Euro olarak uygulanmaktadır.</li>
        <li><strong>250.000 Euro İstisna Fırsatları:</strong> Ticari, sınai veya ofis niteliğindeki mülklerin konuta dönüştürülmesi projelerinde veya koruma altındaki tarihi binaların restorasyonunda bölge fark etmeksizin 250.000 Euro sınırı korunmaktadır.</li>
      </ul>

      <div class="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg my-6">
        <p class="text-amber-900 font-medium"><strong>Kritik Yasal Kural:</strong> 800.000€ ve 400.000€ kategorisindeki mülklerin en az 120 metrekare büyüklüğünde ve tek bir bağımsız tapu olması şarttır. Ayrıca Golden Visa mülklerinin Airbnb gibi kısa dönemli kiralanması yeni yasayla yasaklanmış olup, yalnızca uzun dönem konut kiralaması serbesttir.</p>
      </div>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Türk Yatırımcılar İçin Programın Temel Avantajları</h3>
      <ul class="list-disc pl-5 space-y-2 mb-6">
        <li><strong>Schengen Vizesiz Dolaşım:</strong> 29 Schengen ülkesine vize kuyruğu olmadan serbest giriş çıkış.</li>
        <li><strong>İkamet Zorunluluğu Yoktur:</strong> Oturum hakkını korumak için Yunanistan'da belirli bir gün sayısı yaşama şartı bulunmamaktadır.</li>
        <li><strong>3 Kuşak Aile Kapsamı:</strong> Yatırımcı, eşi, 21 yaş altı çocukları ve her iki tarafın anne-babaları tek bir başvuru ile oturum kartı alır.</li>
        <li><strong>Euro Bazında Kira Getirisi:</strong> Mülkünüzü uzun dönemli güvenilir kiracılara vererek düzenli döviz getirisi elde edebilirsiniz.</li>
      </ul>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Hukuki Süreç Nasıl İşler?</h3>
      <p>GrecoTurk olarak, Türkiye'deki Yunanistan Başkonsoloslukları üzerinden veya Atina'da noter huzurunda vekaletname tanzimi ile başlayıp, tapu denetimi, satış sözleşmesi ve Göçmenlik Bakanlığı teslimine kadar tüm aşamaları titizlikle yönetiyoruz.</p>
    `
  },
  {
    id: "afm-ve-banka-hesabi-acma",
    title: "Yunanistan'da AFM (Vergi Numarası) ve Banka Hesabı Açılış Kılavuzu",
    summary: "Yunanistan'da gayrimenkul alımı, şirket kurulumu veya oturum izni başvurusu için zorunlu olan AFM vergi numarası ve banka hesabı süreçlerinin ayrıntılı rehberi.",
    category: "Prosedür",
    author: "GrecoTurk Hukuki Danışmanlar",
    date: "18 Ocak 2025",
    readTime: "6 dk okuma",
    imageUrl: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=1000",
    content: `
      <p class="mb-4">Yunanistan'da tapu devrinden elektrik faturası aboneliğine, araç alımından şirket kuruluşuna kadar her yasal işlemin ilk şartı 9 haneli <strong>AFM (Arithmos Forologikou Mitroou)</strong> vergi kimlik numarasıdır.</p>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">AFM Nasıl ve Nereden Alınır?</h3>
      <p class="mb-4">Türkiye Cumhuriyeti vatandaşları Yunanistan'a seyahat etmelerine gerek kalmadan, Türkiye'deki Yunan Konsoloslukları veya Yunanistan'daki avukatlarına verdikleri özel yetkili vekaletname (Power of Attorney) ile AFM numaralarını alabilirler.</p>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Gereken Belgeler</h3>
      <ul class="list-disc pl-5 space-y-2 mb-6">
        <li>Geçerli pasaport sureti (Konsolosluk veya noter tasdikli)</li>
        <li>Doğum kayıt örneği (Formül A / Nüfus Müdürlüğü'nden apostilli)</li>
        <li>Yerleşim yeri / ikametgah belgesi (e-Devlet üzerinden apostilli barkodlu)</li>
        <li>Yunan avukata verilmiş vekaletname</li>
      </ul>

      <div class="bg-sky-50 border-l-4 border-sky-500 p-4 rounded-r-lg my-6">
        <p class="text-sky-900 font-medium"><strong>Mali Temsilci (Fiscal Representative) Şartı:</strong> Yunanistan'da daimi ikametgahı olmayan yabancıların yerel bir vergi temsilcisi bildirmesi kanunen zorunludur. Hukuk büromuz bu mali temsilcilik hizmetini müvekkillerine sağlamaktadır.</p>
      </div>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Yunanistan'da Banka Hesabı Açılışı</h3>
      <p class="mb-4">Avrupa Birliği Bankacılık ve AML (Kara Para Aklamayı Önleme) standartları gereği Yunan bankaları (Eurobank, National Bank of Greece, Alpha Bank, Piraeus Bank) fonların kaynağını detaylı şekilde incelemektedir. İstenen evraklar:</p>
      <ol class="list-decimal pl-5 space-y-2 mb-6">
        <li>Son 3 yıla ait gelir vergisi beyannameleri (Vergi Levhası veya maaş bordrosu)</li>
        <li>SGK hizmet dökümü veya şirket ortaklık belgeleri</li>
        <li>Adres kanıtı niteliğinde güncel fatura (su, elektrik veya doğalgaz)</li>
        <li>Türkiye'deki aktif banka hesabından son 6 aylık hesap dökümü</li>
      </ol>
      <p>Evrakların eksiksiz hazırlanması ve Yunanca yeminli tercümelerinin yapılması durumunda banka hesabı hızlıca aktif hale getirilir.</p>
    `
  },
  {
    id: "tapu-denetimi-ve-hukuki-riskler",
    title: "Yunanistan'da Gayrimenkul Alımında Hukuki Güvenlik ve Tapu Taraması",
    summary: "Tapu dairesinde 20 yıllık mülkiyet geçmişi, ipotek taraması, mühendis uygunluk belgesi ve noter sözleşmesinde dikkat edilecek hususlar.",
    category: "Hukuk & Mevzuat",
    author: "GrecoTurk Hukuki Danışmanlar",
    date: "02 Şubat 2025",
    readTime: "8 dk okuma",
    imageUrl: "https://images.unsplash.com/photo-1603565816030-6b389eeb23cb?auto=format&fit=crop&q=80&w=1000",
    content: `
      <p class="mb-4">Yunanistan emlak piyasasında mülk alırken en kritik aşama, satış bedelinin ödenmesinden önce yapılan hukuki ve teknik denetimdir. Yunanistan'da emlak alım süreci Türkiye'den farklı olarak avukat, mühendis ve noterin zorunlu katılımıyla gerçekleşir.</p>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Tapu Dairesi Taraması (Title Search)</h3>
      <p class="mb-4">Avukatınız ilgili Tapu Sicil Dairesi (Ypothikofilakeio) ve Kadastro Ofisi (Ktimatologio) arşivlerinde geriye dönük en az 20 yılı kapsayan kapsamlı bir inceleme yapar:</p>
      <ul class="list-disc pl-5 space-y-2 mb-6">
        <li>Mülk üzerinde banka ipoteği veya icra takibi var mı?</li>
        <li>Satıcının vergi veya sosyal güvenlik (EFKA) borcu nedeniyle mülke haciz konulmuş mu?</li>
        <li>Geçmiş miras intikallerinde hak iddia edebilecek üçüncü şahıslar mevcut mu?</li>
      </ul>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">2. İnşaat Mühendisi Raporu (Engineer's Certificate)</h3>
      <p class="mb-4">Yunan kanunları gereğince noter satışı için bağımsız bir inşaat mühendisinin mülkün belediye imar onayına birebir uygun olduğunu teyit etmesi zorunludur. Kaçak kapatılmış balkon, projesiz oda bölmesi veya imar ihlalleri varsa satıcı bunları yasallaştırmadan (legalization) satış yapılamaz.</p>

      <div class="bg-emerald-50 border-l-4 border-emerald-500 p-4 rounded-r-lg my-6">
        <p class="text-emerald-900"><strong>Alım Masrafları Özeti:</strong> Gayrimenkul alımında yaklaşık %3 oranında Gayrimenkul Devir Vergisi (FMA), yaklaşık %1-1.5 noter harcı, %1 tapu tescil harcı ve avukatlık ücreti bütçelenmelidir.</p>
      </div>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Noter Satış Sözleşmesi ve Mülkiyetin Tescili</h3>
      <p>Tüm incelemeler olumlu sonuçlandığında taraflar veya vekilleri noterde nihai satış sözleşmesini imzalar. Bedel Yunan bankası üzerinden resmi transfer veya bloke çekle ödenir. Tapunun sicile işlenmesiyle alıcı resmi malik sıfatını kazanır.</p>
    `
  },
  {
    id: "sirket-kurulumu-ike",
    title: "Yunanistan'da Şirket Kurulumu: IKE Şirket Türü ve Vergi Avantajları",
    summary: "Avrupa pazarında ticaret yapmak isteyen girişimciler için esnek sermayeli IKE şirket yapısı, kuruluş adımları ve kurumlar vergisi oranları.",
    category: "Hukuk & Mevzuat",
    author: "GrecoTurk Hukuki Danışmanlar",
    date: "12 Şubat 2025",
    readTime: "7 dk okuma",
    imageUrl: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1000",
    content: `
      <p class="mb-4">Yunanistan, stratejik Akdeniz konumu, AB üyesi olması ve Türkiye'ye coğrafi yakınlığı ile şirket kurmak isteyen Türk iş insanları için büyük fırsatlar sunmaktadır. Yabancı yatırımcıların en çok tercih ettiği şirket türü <strong>IKE (Idiotiki Kefalaiouchiki Etaireia)</strong> yani Özel Sermaye Şirketidir.</p>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">IKE Şirketinin Avantajları</h3>
      <ul class="list-disc pl-5 space-y-2 mb-6">
        <li><strong>1 Euro Asgari Sermaye:</strong> Şirket kuruluşunda yüksek bir sermaye blokesi gerekmez, 1 Euro sembolik sermaye ile kurulabilir.</li>
        <li><strong>Hızlı Tescil:</strong> Elektronik Ticaret Sicil Odası (GEMI) üzerinden ortalama 3-5 iş günü içerisinde kuruluş tamamlanır.</li>
        <li><strong>Yabancı Ortaklık:</strong> Ortakların veya müdürün Yunan vatandaşı olması zorunlu değildir; %100 yabancı sermayeli olabilir.</li>
        <li><strong>AB KDV Numarası (VIES):</strong> Avrupa içi B2B ticaretlerde KDV'siz (Reverse Charge) fatura kesme imkanı tanır.</li>
      </ul>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Yunanistan'da Kurumsal Vergi Oranları</h3>
      <p class="mb-4">Yunanistan'da şirket kârları üzerinden <strong>%22 Kurumlar Vergisi</strong> uygulanmaktadır. Ortaklara dağıtılan temettü (dividend) stopaj oranı ise sadece <strong>%5</strong>'tir. Bu oran diğer birçok AB ülkesine göre oldukça rekabetçidir.</p>

      <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg my-6">
        <p class="text-blue-900"><strong>Çifte Vergilendirmeyi Önleme Anlaşması:</strong> Türkiye ile Yunanistan arasında yürürlükte olan anlaşma sayesinde, Yunanistan'da ödenen kurumlar vergisi Türkiye'de mahsup edilebilmekte ve mükerrer vergilendirme engellenmektedir.</p>
      </div>
    `
  },
  {
    id: "aile-haklari-ve-vatandaslik",
    title: "Golden Visa ile Aile Hakları ve Yunanistan Vatandaşlığına Geçiş",
    summary: "Eş, 21 yaş altı çocuklar ve ebeveynlerin oturum izinleri, eğitim hakları ve 7 yıl sonunda AB pasaportu başvurusu süreci.",
    category: "Prosedür",
    author: "GrecoTurk Hukuki Danışmanlar",
    date: "24 Şubat 2025",
    readTime: "6 dk okuma",
    imageUrl: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&q=80&w=1000",
    content: `
      <p class="mb-4">Yunanistan Golden Visa programının en cömert özelliklerinden biri, tek bir gayrimenkul yatırımı ile üç nesli kapsayan bir oturum izni sunmasıdır.</p>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Aile Üyelerinin Hak Kapsamı</h3>
      <ul class="list-disc pl-5 space-y-2 mb-6">
        <li><strong>Yatırımcının Eşi:</strong> Resmi evlilik veya Yunanistan'da tanzim edilen noter tasdikli birliktelik sözleşmesi ile hak kazanır.</li>
        <li><strong>Çocuklar:</strong> Başvuru tarihinde 21 yaşını doldurmamış ve bekar olan çocuklar programa dahildir. 21 yaşından sonra 24 yaşına kadar uzatılabilir.</li>
        <li><strong>Anne ve Babalar:</strong> Hem ana yatırımcının hem de eşinin anne ve babası hiçbir gelir veya bağımlılık testi aranmaksızın programa dahil edilir.</li>
      </ul>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Yunanistan Vatandaşlığına Giden Yol</h3>
      <p class="mb-4">Golden Visa sahipleri Yunanistan'da fiilen yaşamaya karar verirlerse:</p>
      <ul class="list-disc pl-5 space-y-2 mb-6">
        <li>Yunanistan'da kesintisiz 7 yıl ikamet ettiklerinde (yılda en az 183 gün ülkede bulunarak),</li>
        <li>Temel düzeyde Yunanca dil sınavını (B1 seviyesi) ve genel kültür sınavını geçtiklerinde,</li>
        <li>Yunanistan vatandaşlığına başvurarak Avrupa Birliği pasaportu sahibi olabilirler.</li>
      </ul>
      <p>Yunanistan devlet okullarında eğitim alan çocuklar ise eğitim sürelerini tamamladıklarında bağımsız vatandaşlık hakkı kazanabilirler.</p>
    `
  },
  {
    id: "yunanistanda-gunluk-yasam-ve-saglik",
    title: "Yunanistan'da Yaşam, Sağlık Sistemi (AMKA) ve Sosyal Uyum",
    summary: "Oturum kartınızı aldıktan sonra günlük hayat: AMKA numarası, özel sağlık sigortası, uluslararası okullar ve bankacılık alışkanlıkları.",
    category: "Yaşam",
    author: "GrecoTurk Hukuki Danışmanlar",
    date: "01 Mart 2025",
    readTime: "5 dk okuma",
    imageUrl: "https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&q=80&w=1000",
    content: `
      <p class="mb-4">Yunanistan, Akdeniz yaşam tarzı, misafirperver halkı ve zengin kültürel bağları sayesinde Türk vatandaşlarının en kolay adapte olduğu Avrupa ülkesidir.</p>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Sağlık Hizmetleri ve Özel Sigorta</h3>
      <p class="mb-4">Golden Visa başvurusu için Yunanistan'da geçerli kapsamlı bir özel sağlık sigortası yaptırılması kanunen zorunludur. Bu sigorta özel hastanelerde (örneğin Atina'daki Hygeia ve Iaso hastaneleri) yüksek standartta tedavi güvencesi sağlar. Ayrıca acil durumlarda devlet hastanelerinden de faydalanılabilir.</p>

      <h3 class="text-2xl font-bold text-gray-900 mt-8 mb-4">Çocuklar İçin Eğitim Seçenekleri</h3>
      <p class="mb-4">Atina ve Selanik'te İngilizce, Fransızca ve Almanca eğitim veren, Uluslararası Bakalorya (IB) diploması sunan çok sayıda prestijli okul mevcuttur (ACS Athens, St. Catherine's British School, Campion School). Bu okullardan mezun olan öğrenciler doğrudan İngiltere, ABD ve Avrupa üniversitelerine kabul almaktadır.</p>
    `
  }
];
